import { Alert, Form, Radio, Space, Typography } from "antd";
import { type FormInstance } from "antd/lib/form";
import { useTranslation } from "react-i18next";

import { type AiAutomationTaskSender } from "@fitness-app/data-models/entities/AutomationTemplate";

interface TaskSenderFieldProps {
  formController?: FormInstance<any>;
  /** The edited automation's advisorEnabled designation — the advisor sender only works for its clients. */
  advisorEnabled?: boolean | null;
}

const senders: AiAutomationTaskSender[] = ["trainer", "advisor"];

/**
 * TRE-2072 — "Nadawca" of a scheduled AI message / report: the trainer (a message in
 * the client's chat, the pre-TRE-2072 behaviour) or the advisor (a new conversation the
 * client can reply to). Shared by AiAgentMessageTaskForm and AiReportTaskForm.
 */
export const TaskSenderField = ({ formController, advisorEnabled }: TaskSenderFieldProps) => {
  const { t } = useTranslation("automation");
  const sender = Form.useWatch("sender", formController) as AiAutomationTaskSender | undefined;

  return (
    <>
      <Form.Item name="sender" label={t("programAutomation.taskSender.label")} rules={[{ required: true }]}>
        <Radio.Group>
          <Space direction="vertical">
            {senders.map((value) => (
              <Radio key={value} value={value}>
                {t(`programAutomation.taskSender.${value}`)}
                <Typography.Text type="secondary" className="ml-2">
                  — {t(`programAutomation.taskSender.${value}Hint`)}
                </Typography.Text>
              </Radio>
            ))}
          </Space>
        </Radio.Group>
      </Form.Item>

      {sender === "advisor" && (
        <Form.Item wrapperCol={{ offset: 8, span: 14 }}>
          <Space direction="vertical" className="w-full">
            {advisorEnabled !== true && (
              <Alert type="warning" showIcon message={t("programAutomation.taskSender.advisorRequiresFlag")} />
            )}
            <Typography.Text type="secondary">{t("programAutomation.taskSender.nightHint")}</Typography.Text>
          </Space>
        </Form.Item>
      )}
    </>
  );
};
